export const isSafari = (userAgent: string) => {
  const ua = userAgent.toLowerCase();
  const fd = (ss: string) => ua.indexOf(ss) > -1;
  const nf = (ss: string) => ua.indexOf(ss) === -1;
  const a = fd('safari/');
  const b = nf('chrome/');
  const c = nf('qq/') && nf('mqqbrowser');
  return a && b && c;
};
